import AvatarSpeechBubble from 'components/dashboard/your-referrals/AvatarSpeechBubble';
import RoundedButton from 'components/RoundedButton';
import { useUIStore } from 'hooks/stores/useUIStore';
import { AvatarOnRubberRing } from './AvatarOnRubberRing';
import { ReferralInviteProgressBar } from './FriendsInvitedProgress';
import styles from './ReferralBeachProgressSection.module.css';
import { MAX_REFERRALS } from '@daymade/common-lib/constants';

interface ReferralBeachProgressSectionProps {
  loading?: boolean;
  numberOfInvited: number;
  referrerName?: string;
  referrerAvatarUrl?: string;
}

export const ReferralBeachProgressSection = ({
  loading,
  numberOfInvited,
  referrerName,
  referrerAvatarUrl,
}: ReferralBeachProgressSectionProps) => {
  const uiStore = useUIStore();

  return (
    <div className={styles.root}>
      <h3 className="aboutUsTypographyHeaderMedium">
        {loading ? '-' : numberOfInvited}/{MAX_REFERRALS} friends invited
      </h3>
      <ReferralInviteProgressBar
        invitedCount={numberOfInvited}
        totalAllowed={MAX_REFERRALS}
      />
      <p className="textAlignCenter noMargin">
        Win <strong>up to £5,000</strong> every time one of your friends wins a
        prize in our weekly draws
      </p>
      <RoundedButton
        rebrandDm2025
        onClick={() =>
          uiStore.setShowInviteFriendsModal(
            true,
            numberOfInvited >= MAX_REFERRALS,
          )
        }
      >
        Invite friends
      </RoundedButton>
      {referrerName && (
        <div className={styles.speechBubbleContainer}>
          <div className={styles.avatar}>
            <AvatarOnRubberRing avatarUrl={referrerAvatarUrl} />
          </div>
          <AvatarSpeechBubble>
            <p className="textWhite" title={referrerName}>
              You were referred by <strong>{referrerName}</strong>
            </p>
          </AvatarSpeechBubble>
        </div>
      )}
    </div>
  );
};
